var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#D42216"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6536 9.06387C13.0121 8.9649 13.3967 8.98134 13.7434 9.11047C14.0902 9.23959 14.3783 9.47361 14.5596 9.77356L14.6202 9.88534L15.1624 10.9889C15.327 11.3238 15.3804 11.6957 15.316 12.0582C15.2517 12.4208 15.0724 12.758 14.8004 13.0279L14.6915 13.1269L13.8372 13.8569C13.6832 13.9904 13.7987 14.5073 14.3557 15.391C14.8569 16.1862 15.2648 16.5576 15.4655 16.5778H15.5007L15.5441 16.5703L17.2232 16.0999C17.4488 16.0365 17.6897 16.034 17.9168 16.0927C18.144 16.1514 18.3479 16.2687 18.5042 16.4308L18.5787 16.517L19.6902 17.9274C19.908 18.2038 20.0166 18.54 19.998 18.8805C19.9793 19.221 19.8347 19.5455 19.5878 19.8006L19.4879 19.8952L19.0439 20.2808C18.6453 20.6265 18.1466 20.8602 17.6072 20.954C17.0678 21.0477 16.5104 20.9976 16.0011 20.8096C14.4163 20.2245 12.9764 18.8877 11.6683 16.8126C10.3578 14.7323 9.81315 12.9191 10.0564 11.3662C10.13 10.8968 10.3411 10.4544 10.6671 10.086C10.9932 9.71762 11.4221 9.43699 11.9083 9.27393L12.0664 9.22592L12.6536 9.06387Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPhone);
export default __webpack_public_path__ + "static/media/infoPhone.815aee896a0a92b3bb76c4a46b416f6a.svg";
export { ForwardRef as ReactComponent };